import React, { useCallback, useMemo } from 'react';
import { useSelector } from "react-redux";
import LoadingBox from "../../../../components/LoadingBox";
import { MAP_ELEMENT } from '../../../../contexts/WorldMapContext/constants';
import { selectDashboard } from "../../../../util/store/selectors";
import { FISH_TYPE, fishType, OPERATION_TYPE, productionAreas, siteType } from "../../../../util/varibles/constants";
import { getProdAreaName } from "../../../../util/varibles/global";
import { openSitePopup } from '../../../LocationPage/Sites/SiteDetail';
import FishDisease from "../../_components/FishDisease";
import Phone from "../../_components/Phone";
import Position from "../../_components/Position";
import Weather from "../../_components/Weather";
import stylesParent from "../style.module.scss";
import Operation from "./Operations/Operation";
import styles from "./style.module.scss";

interface IProps {
    data: any
    operations: any
    productionAreas: any
    loading: boolean
    weather: any
}

const Site: React.FC<IProps> = ({ data }) => {
    const {
        address,
        name,
        position,
        type,
        site_type = FISH_TYPE.PRODUCTION,
        id,
        diseases = [],
        prod_area,
        unit_diseases
    } = data;

    const { production_area = {} } = diseases[0] || {};
    const productAreaId = prod_area || production_area.id;
    const operations = useSelector(selectDashboard.operations);

    const productionArea = useMemo(() => {
        return productionAreas.find(item => item.id === `${productAreaId}`)
    }, [productAreaId]);

    const listOfOperation = operations.reduce((list: any, item: any) => {
        const { operation_type } = item.operation;
        switch (operation_type) {
            case OPERATION_TYPE.HARVEST: {
                const { site = { id: '' }, sites = [] } = item.operation;
                const listOfSite = sites.length > 0 ? sites : [site]
                if (listOfSite.some((item: any) => item.id === id))
                    return [...list, item]
                return list;
            }
            case OPERATION_TYPE.TREATMENT: {
                const { id: site_id = '' } = item.operation.site || {};
                if (site_id === id)
                    return [...list, item]
                return list;
            }
            case OPERATION_TYPE.TRANSPORT: {
                const {
                    source: { id: source_id } = { id: '' },
                    destination: { id: destination_id } = { id: '' }
                } = item.operation;
                if (source_id === id || destination_id === id)
                    return [...list, item]
                return list;
            }
            default:
                return list
        }
    }, []);

    const handleClick = useCallback((data: { id: string, name: string }) => {
        openSitePopup(data);
    }, []);

    return <>
        <div className={[stylesParent.header, "cursor-pointer"].join(" ")} onClick={() => handleClick(data)}>
            <div>{name}</div>
        </div>
        <div className={stylesParent.body}>
            <div className={styles['container-info']}>
                <Phone phone={address} />
                <div className={styles['line-info']}>
                    <span>Type:</span>
                    <span>{siteType[type].name}</span>
                </div>
                <div className={styles['line-info']}>
                    <span>Fish type:</span>
                    <span>{fishType[site_type] ? fishType[site_type].name : ''} </span>
                </div>
                <Position {...{ lat: position.latitude, lng: position.longitude }} />
                <div className={styles['line-info']}>
                    <span>Production area:</span>
                    <span>{productionArea ? getProdAreaName(productionArea) : ''}</span>
                </div>
            </div>
            <div className={styles['container-weather']}>
                <Weather data={{ id, name, type: MAP_ELEMENT.SITE }} />
            </div>
            <div className={[styles['container-weather'], 'pb-0'].join(' ')}>
                <div className={styles.title}>
                    <div>Lice, Disease</div>
                </div>
                <div className='text-comment ml-20 font-s4'>
                    (The info. is for current week and will be updated each week)
                </div>
                <FishDisease data={diseases} unit_diseases={unit_diseases} />
            </div>
            <div className={[styles['container-weather'], 'pb-0'].join(' ')}>
                <div className={styles.title}>
                    <div>Incoming operation. ({listOfOperation.length})</div>
                </div>
                <div className={stylesParent.operations}>
                    {listOfOperation.length === 0 && <LoadingBox message="There is no ongoing operation today." />}
                    {listOfOperation.map((data: any, index: any) => <Operation key={index} data={data} />)}
                </div>
            </div>
        </div>
    </>;
};

export default Site;